module["exports"] = [
  " s/n.",
  ", #",
  ", ##",
  " #",
  " ##"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/es/address/building_number.js
// module id = 737
// module chunks = 0